import type { Ref } from 'vue';
import { toRef } from 'vue';

import { useI18nStore } from '@modules/i18n/store';

export interface LocaleComposable {
  currentLocale: Ref<string>;
  fallbackLocale: Ref<string | undefined>;
}

export default function useLocale(): LocaleComposable {
  const localeStore = useI18nStore();
  const currentLocale = toRef(localeStore, 'currentLocale');
  const fallbackLocale = toRef(localeStore, 'fallbackLocale');

  return {
    currentLocale,
    fallbackLocale,
  };
}
